import React from "react";
import "./HeroSection.css";
import { useTranslation } from "react-i18next";
function HeroSection() {
  const { t } = useTranslation("home");
  return (
    <section className="heroSection">
      <div className="container">
        <div className="heroSection-content">
          <h1>{t("heroSection.heading")}</h1>
          <p>{t("heroSection.content")}</p>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
